import { TariffEntity } from 'backend-entity';

export type CrmGetAvailableCatalogTariffsResponseDto = Pick<
  TariffEntity,
  'id' | 'name' | 'ident' | 'duration' | 'durationUnit'
> & {
  availableVehicleCount: number;
};
